<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="30%" @close="resetFields">
      <div slot="content">
        <el-form ref="form" :model="formData" label-position="top" :rules="rules">
          <div v-show="checkType">
            <el-row>
              <el-form-item label="로그 아이디" prop="applogId" label-width="120px"><el-input placeholder="아이디를 입력하세요" v-model="formData.applogId"></el-input></el-form-item>
            </el-row>
          </div>
          <el-row>
            <el-form-item label="로그 경로" label-width="120px"><el-input placeholder="경로를 입력하세요" v-model="formData.applogDir"></el-input></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="로그 타입" label-width="120px">
              <el-select v-model="formData.applogType" placeholder="타입 선택" class="LogSettingSearchSelect">
                <el-option v-for="(item, index) in logTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="로그 파일형태" label-width="120px">
              <el-radio-group v-model="formData.patternFlag" @change="selectPattern" :disabled="!checkType">
                <el-radio v-model="formData.patternFlag" label="N">고정형 로그파일</el-radio>
                <el-radio v-model="formData.patternFlag" label="Y">패턴형 로그파일</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="로그 파일명" label-width="120px">
              <span v-show="(formData.patternFlag === 'N')">
                <el-input placeholder="파일명을 입력하세요" v-model="formData.applogFile" :disabled="formData.applogFileAttrib === 'D'"></el-input>
              </span>
              <span v-show="(formData.patternFlag === 'Y')">
                <el-row type="flex">
                  <el-input class="mr-r4" placeholder="패턴 앞" v-model="formData.beforePattern" :disabled="formData.applogFileAttrib === 'D'"></el-input>
                  <el-input class="mr-r4" placeholder="패턴(예:YYYYMMDD)" v-model="formData.pattern" :disabled="formData.applogFileAttrib === 'D'"></el-input>
                  <el-input placeholder="패턴 뒤" v-model="formData.afterPattern" :disabled="formData.applogFileAttrib === 'D'"></el-input>
                </el-row>
              </span>
            </el-form-item>
          </el-row>
          <el-row>
            <!-- 0429  수정 -->
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="로그 저장" label-width="120px">
                  <el-select v-model="formData.label" @change="setAppLogLabel" placeholder="로그저장 선택" class="LogSettingSearchSelect">
                    <el-option v-for="(item, index) in logStores" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="파일/디렉토리" label-width="120px">
                  <el-select v-model="formData.applogFileAttrib" placeholder="파일/디렉토리 선택" class="LogSettingSearchSelect" @change="changeFileAttrib">
                    <el-option v-for="(item, index) in fileAndDirectoryList" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="실시간 전송"><el-checkbox v-model="formData.applogRealtimeSendFlag" true-label="1" false-label="0"></el-checkbox></el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="삭제 수행"><el-checkbox v-model="formData.applogRawDelFlag" true-label="1" false-label="0" @change="changeDelFlag"></el-checkbox></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="삭제 주기">
                  <el-select v-model="formData.applogRawDelInteval" :disabled ="!checkDelFlag()" placeholder="일간" class="LogSettingSearchSelect">
                    <el-option v-for="(item, index) in deleteTimeList" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <!-- 0429 수정끝 -->
              </el-col>
            </el-row>
          </el-row>
          <el-row>
            <el-form-item label="정렬 순서" label-width="120px"><el-input-number :min="1" placeholder="정렬순서를 입력하세요" v-model="formData.orderbyIndex" controls-position="right"></el-input-number></el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="로그 설명" label-width="120px">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="로그 설명을 입력하세요"
                v-model="formData.applogDesc"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <span v-show="checkType">
          <el-button size="large" type="solid" @click="addSettingApplog">저장</el-button>
        </span>
        <span v-show="!checkType">
          <el-button size="large" type="solid" @click="updateSettingApplog">저장</el-button>
        </span>
        <el-button size="large" @click="close">취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import ApplogSettingAPI from '@/api/settings/log/app-log-setting';
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';

export default {
  name: 'WAppLogPopup',
  components: {
    WSettingSlidingPopup,
  },
  props: {
    selectApplogGroup: {
      type: Object,
    },
    type: {
      type: String,
    },
    settingData: {
      type: Object,
      deafult: {},
    },
  },
  watch: {
    type: {
      handler() {
        this.checkType = (this.type === 'Add');
        this.title = (this.checkType) ? '로그 추가' : '로그 수정';
        if (this.checkType) {
          this.resetFormData();
        }
      },
      immediate: true,
    },
    settingData() {
      if (this.type !== 'Add') {
        this.formData = this.settingData;
      } else {
        this.resetFormData();
      }
      if (this.formData.patternFlag === 'Y') {
        const appName = this.formData.applogFile;
        const patternArray = appName.split(this.formData.pattern);
        this.formData.beforePattern = patternArray[0];
        this.formData.afterPattern = patternArray[1];
      }
    },
    immediate: true,
  },
  data() {
    return {
      title: '로그 추가',
      checkType: true,
      activeRadio: 'N',
      formData: {
        applogId: null,
        applogDir: null,
        applogType: 'T',
        label: 'DF',
        applogFileAttrib: 'F',
        applogSaveDbFlag: 1,
        applogSaveFileFlag: 1,
        patternFlag: 'N',
        applogRawDelFlag: 0,
        applogRealtimeSendFlag: 0,
        applogRawDelInteval: 'D',
        orderbyIndex: null,
        applogDesc: null,
      },
      logList: [],
      rules: {
        applogId: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
      },
      logTypeList: [
        { label: '텍스트', value: 'T' },
        { label: '바이너리', value: 'B' },
        { label: 'MySql Load', value: 'ML' },
      ],
      logStores: [
        { label: 'DB.File', value: 'DF' },
        { label: 'DB', value: 'D' },
        { label: 'File', value: 'F' },
        { label: 'NONE', value: 'N' },
      ],
      fileAndDirectoryList: [
        { label: '파일', value: 'F' },
        { label: '디렉토리', value: 'D' },
      ],
      deleteTimeList: [
        { label: '일간', value: 'D' },
        { label: '주간', value: 'W' },
        { label: '월간', value: 'M' },
        { label: '연간', value: 'Y' },

      ],
      patternFlag: true,
    };
  },
  methods: {
    /**
     * 삭제주기 체크시 작동
     * @author leesy918
     * @return {[type]} [description]
     */
    changeDelFlag() {
      if (!this.checkDelFlag()) {
        this.formData.applogRawDelFlag = '0';
      } else {
        this.formData.applogRawDelInteval = 'D';
      }
    },

    checkDelFlag() {
      return (this.formData.applogRawDelFlag === '1');
    },
    /**
     * 선택한 로그저장 방식에 따른 설정
     * @author leesy918
     * @param  {[type]} data [description]
     */
    setAppLogLabel(data) {
      switch (data) {
        case 'DF':
          this.formData.applogSaveDbFlag = 1;
          this.formData.applogSaveFileFlag = 1;
          break;
        case 'D':
          this.formData.applogSaveDbFlag = 1;
          this.formData.applogSaveFileFlag = 0;
          break;
        case 'F':
          this.formData.applogSaveDbFlag = 0;
          this.formData.applogSaveFileFlag = 1;
          break;
        case 'N':
          this.formData.applogSaveDbFlag = 0;
          this.formData.applogSaveFileFlag = 0;
          break;
        default:
      }
    },
    /**
     * 패턴 bool 값 설정
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectPattern(data) {
      this.formData.patternFlag = data;
      if (data === 'N') {
        this.patternFlag = true;
      } else {
        this.patternFlag = false;
      }
    },
    /**
     * 데이터 Null 처리
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    convertNullData(data) {
      return isNil(data) ? '' : data;
    },
    /**
     * 로그 추가
     * @author leesy918
     */
    addSettingApplog() {
      this.$refs.form.validate().then((success) => {
        if (this.formData.patternFlag === 'Y') {
          this.formData.applogFile = `${this.convertNullData(this.formData.beforePattern)}${this.convertNullData(this.formData.pattern)}${this.convertNullData(this.formData.afterPattern)}`;
        }
        if (success) {
          this.formData.serverId = this.selectApplogGroup.serverId;
          this.formData.applogGroupId = this.selectApplogGroup.applogGroupId;
          if (this.formData.applogRawDelFlag === '0') {
            this.formData.applogRawDelInteval = '';
          }
          ApplogSettingAPI.addApplogInGroup(this.formData).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그', true));
              this.$emit('addApplogInGroup');
              this.close();
              this.reset();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '로그', false));
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    /**
     * 로그 업데이트 적용
     * @author leesy918
     * @return {[type]} [description]
     */
    updateSettingApplog() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.formData.patternFlag === 'Y') {
            this.formData.applogFile = `${this.convertNullData(this.formData.beforePattern)}${this.convertNullData(this.formData.pattern)}${this.convertNullData(this.formData.afterPattern)}`;
          }
          if (this.formData.applogRawDelFlag === '0') {
            this.formData.applogRawDelInteval = '';
          }
          ApplogSettingAPI.updateApplogInGroup(this.formData).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그', true));
              this.$emit('addApplogInGroup');
              this.close();
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    reset() {
      this.formData = {};
    },
    open() {
      this.$refs.slidingPopup.open();
    },
    close() {
      this.$refs.form.resetFields();
      this.$refs.slidingPopup.close();
    },
    resetFormData() {
      this.formData = {
        applogId: '',
        applogDir: null,
        applogType: 'T',
        label: 'DF',
        applogFileAttrib: 'F',
        applogSaveDbFlag: '1',
        applogSaveFileFlag: '1',
        patternFlag: 'N',
        applogRawDelFlag: '0',
        applogRealtimeSendFlag: '0',
        applogRawDelInteval: 'D',
        orderbyIndex: null,
        applogDesc: null,
      };
    },
    resetFields() {
      this.$refs.form.resetFields();
    },
    /**
     * 파일/디렉토리에서 디렉토리 선택 시 로그 파일명 항목을 초기화한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    changeFileAttrib() {
      this.formData.applogFile = '';
      this.formData.beforePattern = '';
      this.formData.pattern = '';
      this.formData.afterPattern = '';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Applog/popup/AppLogPopup.vue